module.exports = __webpack_public_path__ + "static/img/no_data.5a73fc99.png";